import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const categoriesForOptionsSelector: Selector<ReduxState, SelectOption[] | void> = state => state.categories.categoriesForOptions
export default categoriesForOptionsSelector
